import * as _ from 'underscore';

import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField';
import SelectField from '../../../../_common/platform/ts/SelectField';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import { themeId, themeFields } from '../config';
// Theme dispatcher module
import * as appTheme from '../../../../_common/platform/ts/appTheme';
// Any dependency themes, which should be initialized before this one
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';
import { ThemePreview } from './ThemePreview';
import StringField from '../../../../_common/platform/ts/StringField';

// CSS template for the widget
const template = require('!!raw-loader!pdc-widget-pivot/src/mainTheme.template.css').default;

// A hack, to make sure that TS compiler will include this module as dependency in generated AMD
template;

declare var Color: any;

// This array, which saves all glob objects, on which theme was initialized
// It's used to make sure that `init` is launched only once for each glob.
// Here, it's possible that platform will run init for widgetTheme more than 1 time.
var _init = [];

export function init(glob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    // Init parent theme
    widgetTheme(glob);

    // Register section, which will be displayed on the left of theme edit component
    appTheme.registerSections([
        {
            id: themeId,
            name: 'Pivot Grid',
            parent: 'widget',
            preview: ThemePreview,
            previewClassName: 'preview-widget preview-widget-pivot',

            themeType: 'Widget Pivot',
            visibility: ['application', 'workspace', 'pdc-widget-pivot']
        }
    ]);

    appTheme.registerGroups([
        {
            id: 'pivot-experimental-Staffplan',
            name: 'Experimental for VoresPlan',
            section: 'widget-pivot'
        }
    ]);

    // gray-base    = main fore coloe
    // surface-bg   = main background

    // Register theme variables
    appTheme.registerVars([
        // HEADER font color
        {
            id: themeFields.headerFrontColor,
            param: new ColorBoxField(
                glob,
                'Header Font Color',
                [],
                function (theme) {
                    return theme['on-secondary'];
                },
                { hideTransparency: true }
            ),
            section: 'widget-pivot',
            deps: ['on-secondary']
        },
        // HEADER background color
        {
            id: themeFields.headerBGColor,
            param: new ColorBoxField(
                glob,
                'Header Background Color',
                [],
                function (theme) {
                    return theme['secondary-bg'];
                },
                { hideTransparency: false }
            ),
            section: 'widget-pivot',
            deps: ['secondary-bg']
        },
        // ROW font color
        {
            id: 'widget-pivot-row-color',
            param: new ColorBoxField(
                glob,
                'Row Font Color',
                [],
                function (theme) {
                    return theme['gray-base'];
                },
                { hideTransparency: true }
            ),
            section: 'widget-pivot',
            deps: ['gray-base']
        },
        // ROW background color
        {
            id: 'widget-pivot-rowbg-color',
            param: new ColorBoxField(
                glob,
                'Row Background Color',
                [],
                function (theme) {
                    return theme['surface-bg'];
                },
                { hideTransparency: false }
            ),
            section: 'widget-pivot',
            deps: ['surface-bg']
        },

        // SUMMARY background color:
        {
            id: 'widget-pivot-rowsum-color',
            param: new ColorBoxField(
                glob,
                'Row Grand Total Background',
                [],
                function (theme) {
                    if (Color(theme['surface-bg']).dark()) {
                        return Color(theme['surface-bg'])
                            .mix(Color(theme['secondary-bg']), 0.1)
                            .mix(Color('#FFFFFF'), 0.07)
                            .hexString();
                    }
                    return Color(theme['surface-bg'])
                        .mix(Color(theme['secondary-bg']), 0.1)
                        .mix(Color('#000000'), 0.05)
                        .hexString();
                },
                { hideTransparency: false }
            ),
            section: 'widget-pivot',
            deps: ['surface-bg']
        },

        //The whole background color:
        {
            id: 'widget-pivot-bg-color',
            param: new ColorBoxField(
                glob,
                'Bottom Background Color',
                [],
                function (theme) {
                    return theme['surface-bg'] || '#FFFFFF';
                },
                { hideTransparency: false }
            ),
            section: 'widget-pivot',
            deps: ['surface-bg']
        },
        {
            id: 'widget-pivot-lines-color',
            param: new ColorBoxField(glob, 'Vertical & Horizontal Lines Color', [], '#DDDDDD', {
                hideTransparency: true
            }),
            section: 'widget-pivot'
        },
        {
            id: 'widget-pivot-hide-empty-summary-cells',
            param: new BooleanField(glob, 'Hide Empty Summary Cells', [], true),
            section: 'widget-pivot'
        },
        {
            id: 'widget-pivot-show-column-totals',
            param: new BooleanField(glob, 'Show Column Totals', [], true),
            section: 'widget-pivot'
        },
        {
            id: 'widget-pivot-show-column-grand-totals',
            param: new BooleanField(glob, 'Show Column Grand Totals', [], true),
            section: 'widget-pivot'
        },
        {
            id: 'widget-pivot-show-row-totals',
            param: new BooleanField(glob, 'Show Row Totals', [], true),
            section: 'widget-pivot'
        },
        {
            id: 'widget-pivot-show-row-grand-totals',
            param: new BooleanField(glob, 'Show Row Grand Totals', [], true),
            section: 'widget-pivot'
        },
        {
            id: 'widget-pivot-show-totals-prior',
            param: new SelectField(glob, 'Position of Totals', [], 'none', {
                values: ['none', 'columns', 'rows', 'both'],
                display: ['after columns and rows', 'before columns', 'above rows', 'before columns and rows']
            }),
            section: 'widget-pivot'
        },
        {
            id: themeFields.treeRowHeaderLayout,
            param: new BooleanField(glob, 'Use Tree Row Header Layout', [], true),
            section: 'widget-pivot'
        },
        {
            id: 'widget-pivot-show-field-panel',
            param: new BooleanField(glob, 'Show Field Panel', [], false),
            section: 'widget-pivot'
        },
        {
            id: 'widget-pivot-alignment',
            param: new SelectField(glob, 'Alignment', [], 'default', {
                values: ['default', 'left', 'center', 'right'],
                display: ['default', 'left', 'center', 'right']
            }),
            section: 'widget-pivot'
        },
        {
            id: 'widget-pivot-row-header-alignment',
            param: new SelectField(glob, 'Row Header Alignment', [], 'default', {
                values: ['default', 'left', 'center', 'right'],
                display: ['default', 'left', 'center', 'right']
            }),
            section: 'widget-pivot'
        },
        {
            id: 'tree-row-header-wordWrapEnabled',
            param: new BooleanField(glob, 'Allow long text of the Row Header be wrapped', [], true),
            section: 'widget-pivot'
        },
        {
            id: 'widget-pivot-native-scrollbar',
            param: new BooleanField(glob, 'Native scrollbar', [], true),
            section: 'widget-pivot'
        },
        {
            id: 'widget-pivot-total-pattern',
            param: new StringField(glob, 'Total pattern', [], '{0} Total'),
            section: 'widget-pivot',
            group: 'pivot-experimental-Staffplan'
        },
        {
            id: 'widget-pivot-hide-last-column-headers',
            param: new BooleanField(glob, 'Hide last column headers', [], false),
            section: 'widget-pivot',
            group: 'pivot-experimental-Staffplan'
        },
        {
            id: 'widget-pivot-getdata-for-last-row-only',
            param: new BooleanField(glob, 'Get Data for last Row in a Group only', [], false),
            section: 'widget-pivot',
            group: 'pivot-experimental-Staffplan'
        },
        {
            id: 'widget-pivot-highlight-current-date',
            param: new BooleanField(glob, 'Highlight Current Date', [], false),
            section: 'widget-pivot',
            group: 'pivot-experimental-Staffplan'
        },
        {
            id: 'widget-pivot-highlight-current-date-color',
            param: new ColorBoxField(glob, 'Current Date Highlighting Color', [], '#FA8128', {
                hideTransparency: true
            }),
            section: 'widget-pivot',
            group: 'pivot-experimental-Staffplan'
        },
        {
            id: 'widget-pivot-html-cell',
            param: new BooleanField(glob, 'Can use Html in Cells', [], false),
            section: 'widget-pivot',
            group: 'pivot-experimental-Staffplan'
        }
    ]);

    // Register templates
    appTheme.registerTemplate(template, ['pdc-widget-pivot']);

    appTheme.registerPreRender(function (input) {
        var vars = {};

        //color.luminosity();  //ex: 0.412 (0 is black, 1 is white.)
        // The [WCAG luminosity](http://www.w3.org/TR/WCAG20/#relativeluminancedef) of the color. 0 is black, 1 is white.

        //var colorArr = Color(input['widget-pivot-rowbg-color']).rgbArray();
        //vars['widget-pivot-rowbg-color-r'] = colorArr[0];
        //vars['widget-pivot-rowbg-color-g'] = colorArr[1];
        //vars['widget-pivot-rowbg-color-b'] = colorArr[2];
        //vars['widget-pivot-rowbg-color-op'] = 1.0-(Color(input['widget-pivot-rowbg-color']).luminosity()*0.8);
        //
        //var colorAltArr = Color(input['widget-pivot-rowbgalt-color']).rgbArray();
        //vars['widget-pivot-rowbgalt-color-r'] = colorAltArr[0];
        //vars['widget-pivot-rowbgalt-color-g'] = colorAltArr[1];
        //vars['widget-pivot-rowbgalt-color-b'] = colorAltArr[2];
        //vars['widget-pivot-rowbgalt-color-op'] = 1.0-(Color(input['widget-pivot-rowbgalt-color']).luminosity()*0.8);

        return _.extend(input, vars);
    });
    _init.push(glob);
}
